const CONTEXT_TAG = 'context';
const CONTEXT_BLOCK_RE = new RegExp(`<${CONTEXT_TAG}>[\\s\\S]*?</${CONTEXT_TAG}>`, 'g');
export function buildContextWrappedPrompt(context, prompt) {
    return `<${CONTEXT_TAG}>${JSON.stringify(context)}</${CONTEXT_TAG}>${prompt}`;
}
export function stripContextBlocks(text) {
    if (!text) {
        return text;
    }
    return text.replace(CONTEXT_BLOCK_RE, '').trimStart();
}
